import * as actionTypes from "./actionTypes";
import axios from "../../util/axios-reportonce";
import serverSelect from "../../serverSelect";
import authHeader from "../../services/auth-header";

export const loadListingsSuccess = (data, page) => {
    return {
        type: actionTypes.LOAD_LISTINGS_SUCCESS,
        listings: data.results,
        listingsCount: data.count,
        pagesCount: Math.ceil(data.count / 10),
        page: page,
    };
};

export const loadListingsFail = (errorMessage, errorCode) => {
    return {
        type: actionTypes.LOAD_LISTINGS_FAIL,
        errorMessage: errorMessage,
        errorCode: errorCode,
    };
};

export const loadListingsStart = () => {
    return {
        type: actionTypes.LOAD_LISTINGS_START,
    };
};

export const loadListings = (page, isCorporate=false, filterKwargs={}) => {
    return (dispatch, getState) => {
        if (page !== null) {
            dispatch(loadListingsStart());
            const request_options = authHeader(getState().user);
            const server = serverSelect();
            // Setting default query params
            let request_params = filterKwargs;
            // Adding page and corporate values if they are present
            request_params = {
                ...request_params,
                ...(page !== null && {"page": page}),
                ...(isCorporate !== false && {"is_corporate": isCorporate}),
            }
            request_options['params'] = request_params;
            axios
                .get(`${server}/api/listings`, request_options)
                .then((response) => {
                    dispatch(loadListingsSuccess(response.data, page));
                })
                .catch((error) => {
                    // console.log('[actions.js] loadListings() error = ', error);
                    let errorMessage = error.toString();
                    if (error?.response?.data?.detail) {
                        // .response doesn't always exist, so always double check before trying to use anything passed in the response.
                        errorMessage = error.response.data.detail;
                    }
                    let errorCode = false;
                    if (error?.response?.status) {
                        // .response doesn't always exist, so always double check before trying to use anything passed in the response.
                        errorCode = error.response.status;
                    }
                    dispatch(loadListingsFail(errorMessage, errorCode));
                });
        }
    };
};

export const changeActivePage = (page) => {
    return {
        type: actionTypes.CHANGE_ACTIVE_PAGE,
        page: page,
    };
};
